import Lottie from "react-lottie";
import animationData from "../../lottie/dots-loading.json";
import smokeAnimationData from "../../lottie/smoke.json";
import { useState } from "react";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const smokeOptions = {
  loop: false,
  autoplay: true,
  animationData: smokeAnimationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export default () => {
  const [options, setOptions] = useState(defaultOptions);
  return (
    <div
      onClick={() => {
        setTimeout(() => {
          setOptions(defaultOptions);
        }, 1000);
        // @ts-ignore
        setOptions(smokeOptions);
      }}
    >
      <Lottie options={options} width={200} height={200} />
    </div>
  );
};
